import React, { useCallback, useEffect } from 'react';

// DEPENDENCIES
import isFunction from 'lodash/isFunction';
import { useParams } from 'react-router-dom';

// HOOKS
import { useLogContext } from './logContext';

// FUNCTIONS
import { apiFetch, doCallback } from 'functions.js';

// MAIN COMPONENT
export const getLogData = Component => ({
  fetchArgs,
  ...props
}) => {

  // PROPS
  const { name } = props;

  // REACT ROUTER
  const { recordID } = useParams();

  // HOOKS
  const { updateLogs } = useLogContext();

  // FETCH
  const fetchLog = useCallback(
    (args = {}) => {

      const { endpoints, endpoint = endpoints?.list, params, onSuccess = ({ result }) => result } = fetchArgs || {};

      if (!endpoint || !recordID) return;

      apiFetch({
        method: 'GET',
        endpoint: isFunction(endpoint) ? endpoint(recordID) : endpoint,
        errorMessage: false,
        onSuccess: data => {
          updateLogs({ type: 'LOAD', name, key: 'data', data: doCallback(onSuccess, data)}) 
        },
        onError: data => {
          updateLogs({ type: 'ERROR', name, data }) 
        },
        ...args,
        params: Object.assign({}, isFunction(params) ? params(recordID) : params, args.params)
      })
    },
    [fetchArgs, name, recordID, updateLogs]
  )
  useEffect(
    () => {
      updateLogs({ type: 'LOAD', name, key: 'fetch', fetch: fetchLog});
      fetchLog();
    },
    [name, updateLogs, fetchLog]
  );

  // RENDER
  return (
    <Component {...props} />
  );
}
